export const ICONS = {
  SETTINGS: <>⚙</>,

  CHECKMARK_TRUE: <>☑</>,
  CHECKMARK_FALSE: <>☒</>,

  INFO: <>ℹ</>,
  WARNING: <>⚠</>,
  ERROR: <>!</>,

  UPLOAD: <>⤒</>,
  DOWNLOAD: <>⤓</>,
  PREVIEW: <>↗</>,

  PARTY_POPPER: <>🎉</>,
  DOWNWARD_TREND: <>📉</>,

  REFRESH: <>⟳</>,

  SEND_MAIL: <>📧</>,

  X: <>×</>
}